const messages = {
    accountBox: {
        title: "Oversikt",
        description: "Følg kampanjene og poengene dine raskt.",
        button: "ÅPNE OVERSIKT",
    },
};

export default {
    messages,
};
